// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"62bbcdec","239":"f775159b","433":"5d22762e"}[chunkId] + ".chunk.js";
};